import { getAll } from '@/api/besoin';
import * as allTypes from '@/store/mutation-type';
import * as types from '@/store/modules/bodac/besoin/besoin-mutation-type';
import genererCritereRecherche from '@/services/bodac/besoin/genererCritereRecherche';
import genererGuid from '@/services/general/genererGuid';

function initialState() {
  return {
    items: [],
    totalCount: 0,
    criteresRecherche: genererCritereRecherche(),
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_ITEMS](state, items) {
    state.items = items;
  },
  [types.SET_ADD_ITEM](state, item) {
    state.items.unshift(item);
  },
  [types.SET_TOTAL_COUNT](state, count) {
    state.totalCount = count;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
  [types.SET_CRITERE](state, critere) {
    state.criteresRecherche = critere;
  },
};

const actions = {
  async load({ commit }, data) {
    const { items, totalCount } = (await getAll(data)).data.result;
    items.forEach((item) => {
      item.selected = false;
      item.key = genererGuid();
      item.fieldHasModified = null;
      item.dateDepart = item.dateDepart ? new Date(item.dateDepart) : null;
      item.dateLivraison = item.dateLivraison ? new Date(item.dateLivraison) : null;
    });
    commit(types.SET_TOTAL_COUNT, totalCount);
    commit(types.SET_ITEMS, items);
    return {};
  },
};

const getters = {
  items: state => {
    return state.items;
  },
  totalCount: state => {
    return state.totalCount;
  },
  criteresRecherche: state => {
    return state.criteresRecherche;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
